"use strict";

const loader = document.getElementById("loader");

const isAppleDevice = /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent);

if (loader && isAppleDevice) {
  loader.classList.add("is-apple-device");
}

if (loader) {
  window.addEventListener("load", () => {

    const isHomePage =
      window.location.pathname === "/" ||
      window.location.pathname.endsWith("index.html");

    if (isHomePage) {

      setTimeout(() => {
        loader.classList.add("is-hidden");
      }, 1500);

    } else {

      loader.classList.add("is-hidden");

    }

  });
}

const pageLinks = document.querySelectorAll("a[href]");

pageLinks.forEach((link) => {

  link.addEventListener("click", (event) => {

    const href = link.getAttribute("href");

    if (
      href.startsWith("#") ||
      href.startsWith("http") ||
      link.target === "_blank"
    ) {
      return;
    }

    event.preventDefault();

    const loader = document.getElementById("loader");

    loader.classList.remove("is-hidden");

    setTimeout(() => {
      window.location.href = href;
    }, 500);
  });

});

